import React from 'react'
import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from '../firebase';


const Login = () => {

  const [error,setError] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e)=>{
    e.preventDefault();
    const email = e.target[0].value;
    const password = e.target[1].value;



  try {
      await signInWithEmailAndPassword(auth, email, password)
      navigate("/")
  }
  catch (error) {
    setError(true);
  }


  }

  return (
    <body>
  <div>
    <div className='formContainer'>
    <div className="wave"></div>
    <div className="wave"></div>
    <div className="wave"></div>
      <div className='formWrapper'>
        <span className="logo">ConvoConnect! <img src="icons/talking.png" alt='meeting-icon'/> </span>
        <span className="title">Welcome Back! Login</span>
        <form onSubmit={handleSubmit} >
          <input type='email' placeholder='Email'/>
          <input type='password' placeholder='Password'/>
          <button>Sign In</button>
          {error && <span> Something went wrong </span>}
        </form>
        <p>Don't have an account? <Link to="/register">StartConnecting</Link></p>
        <p>
        Test Case:
        <div>
        email- user@gmail.com
        </div>
        <div>
        password- password
        </div>
        </p>
      </div>
    </div>
  </div>
</body>
  )
}

export default Login